<div class="sa-page">
  <header class="sa-header" *ngIf="started && !submitted">
    <button type="button" class="sa-back" (click)="back()" [disabled]="!canGoBack">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <span>Back</span>
    </button>
    <div class="sa-progress" *ngIf="!loading && groups.length">
      <div class="sa-dots" aria-hidden="true">
        <span
          class="sa-dot"
          *ngFor="let g of groups; let idx = index; trackBy: trackByIndex"
          [class.sa-dot-active]="idx <= groupIndex"
        ></span>
      </div>
      <div class="sa-progress-text">{{ progressText }}</div>
    </div>
  </header>

  <main class="sa-main">
    <div class="sa-state" *ngIf="loading">Loading…</div>
    <div class="sa-state sa-error" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>

    <!-- Start / Instruction page -->
    <section *ngIf="!loading && !errorMessage && !started && !submitted" class="sa-start">
      <div class="sa-card sa-profile">
        <div class="sa-avatar" aria-hidden="true">
          <img *ngIf="profileImageObjectUrl" [src]="profileImageObjectUrl" alt="" />
        </div>
        <div class="sa-profile-text">
          <div class="sa-name">{{ staffName }}</div>
          <div class="sa-meta">{{ staffPayrollId }}</div>
          <div class="sa-meta">{{ staffDesignation }}</div>
          <div class="sa-meta2">{{ staffCampus }}</div>
        </div>
      </div>

      <div class="sa-card">
        <h2 class="sa-card-title">Self‑Assessment Instruction</h2>
        <p class="sa-card-sub">Based on your actual practices over the last 2–3 months, rate yourself on the following:</p>

        <ol class="sa-scale">
          <li><b>1. Not done</b><div>This is not happening.</div></li>
          <li><b>2. Done sometimes</b><div>This happens occasionally, but there is no regular process.</div></li>
          <li><b>3. Done, but inconsistent</b><div>This is happening, but not regularly or not across all classes/staff.</div></li>
          <li><b>4. Done regularly</b><div>This is happening regularly as part of routine work, but follow‑up or impact may not always be strong.</div></li>
          <li><b>5. Done regularly and followed through</b><div>This is happening consistently, and I ensure proper follow‑up and visible results.</div></li>
        </ol>
      </div>

      <button type="button" class="sa-primary" (click)="start()">Start</button>
    </section>

    <!-- Group pages -->
    <section *ngIf="!loading && !errorMessage && started && !submitted" class="sa-group">
      <div class="sa-group-head">
        <div class="sa-group-title">{{ currentGroup.key }}) {{ currentGroup.title }}</div>
        <div class="sa-group-range">{{ currentGroup.rangeLabel }}</div>
      </div>

      <div class="sa-readonly" *ngIf="readonlyMode && readonlyMessage">{{ readonlyMessage }}</div>

      <div class="sa-card sa-questions-card">
        <div
          class="sa-q sa-q-in-card"
          *ngFor="let q of currentGroup.questions; trackBy: trackByQuestionId"
          [attr.id]="'q-' + q.questionId"
        >
          <div class="sa-q-head">
            <span class="sa-sn">{{ q.no }}</span>
            <span class="sa-q-title" *ngIf="q.title">{{ q.title }}</span>
          </div>
          <div class="sa-q-desc" *ngIf="q.questionHtml" [innerHTML]="q.questionHtml"></div>

          <ng-container *ngIf="options$(q.questionId) | async as opts">
            <div class="sa-rating" role="radiogroup" [attr.aria-label]="'Options for question ' + q.no">
              <button
                type="button"
                class="sa-pill"
                *ngFor="let o of opts; trackBy: trackByOptionId"
                [class.sa-pill-active]="selectedRank(q.questionId) === o.optionRank"
                (click)="setOption(q.questionId, o)"
                [title]="o.optionName"
                [disabled]="readonlyMode || submitting"
              >{{ o.optionRank }}</button>
            </div>
            <div class="sa-reason" *ngIf="needsReason(q.questionId)">
              <label class="sa-reason-label" [attr.for]="'reason-' + q.questionId">{{ explainChoiceCopy }}</label>
              <textarea
                class="sa-reason-input"
                rows="3"
                [class.sa-reason-missing]="needsReason(q.questionId) && !(reasons.get(q.questionId) || '').trim() && !readonlyMode"
                [value]="reasons.get(q.questionId) || ''"
                (input)="setReason(q.questionId, ($any($event.target).value))"
                [attr.placeholder]="explainChoiceCopy"
                [disabled]="readonlyMode || submitting"
                [attr.id]="'reason-' + q.questionId"
              ></textarea>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="sa-footer">
        <button type="button" class="sa-link" (click)="showInstruction = true">View Instruction</button>
        <div class="sa-submit-error" *ngIf="submitError">{{ submitError }}</div>
        <div
          class="sa-submit-hint"
          *ngIf="groupIndex < groups.length - 1 && !canGoNext && !readonlyMode && nextDisabledHint"
        >
          {{ nextDisabledHint }}
        </div>
        <div
          class="sa-submit-hint"
          *ngIf="groupIndex === groups.length - 1 && !canSubmit && !submitError && submitDisabledHint"
        >
          {{ submitDisabledHint }}
        </div>
        <div class="sa-footer-actions">
          <button type="button" class="sa-ghost" (click)="back()" [disabled]="!canGoBack">Back</button>
         <button
  type="button"
  class="sa-primary"
  [class.disabled-btn]="!canGoNext"
  *ngIf="groupIndex < groups.length - 1"
  (click)="next()"
>
  Next
</button>
          <button
            type="button"
            class="sa-primary"
            *ngIf="groupIndex === groups.length - 1"
            (click)="submit()"
            [disabled]="!canSubmit"
          >{{ readonlyMode ? 'Submitted' : (submitting ? 'Saving…' : 'Submit') }}</button>
        </div>
      </div>
    </section>
  </main>
</div>

<!-- Instruction modal (outside .sa-page — centers on full screen) -->
  <div class="sa-modal" *ngIf="showInstruction" (click)="showInstruction = false">
    <div class="sa-modal-card" (click)="$event.stopPropagation()">
      <div class="sa-modal-head">
        <h3 class="sa-modal-title">Self‑Assessment Instruction</h3>
        <button type="button" class="sa-modal-close" (click)="showInstruction = false" aria-label="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <p class="sa-modal-sub">Based on your actual practices over the last 2–3 months, rate yourself on the following:</p>
      <ol class="sa-scale sa-scale-modal">
        <li><b>1. Not done</b><div>This is not happening.</div></li>
        <li><b>2. Done sometimes</b><div>This happens occasionally, but there is no regular process.</div></li>
        <li><b>3. Done, but inconsistent</b><div>This is happening, but not regularly or not across all classes/staff.</div></li>
        <li><b>4. Done regularly</b><div>This is happening regularly as part of routine work, but follow‑up or impact may not always be strong.</div></li>
        <li><b>5. Done regularly and followed through</b><div>This is happening consistently, and I ensure proper follow‑up and visible results.</div></li>
      </ol>
    </div>
  </div>

  <app-assessment-submit-confirm
    [open]="showSubmitConfirm"
    mode="confirm"
    theme="sa"
    (confirmed)="confirmSubmit()"
    (cancelled)="cancelSubmitConfirm()"
  ></app-assessment-submit-confirm>

  <app-assessment-submit-confirm
    [open]="submitted && !loading && !errorMessage"
    mode="success"
    theme="sa"
    successMessage="Thank you for submitting your Self-Assessment form!"
    (dismissed)="confirmationBack()"
  ></app-assessment-submit-confirm>

